<template>
  <scoped>
    <button
      :title="title"
      :disabled="disabled"
    >
      <template v-if="image">
        <img
          :alt="title"
          :src="image"
        >
      </template>
      <template v-else>
        {{ title }}
      </template>
    </button>
  </scoped>
</template>

<script setup lang="ts">
  defineProps({
    disabled: {
      default: false,
      required: false,
      type: Boolean,
    },
    image: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    }
  })
</script>

<style scoped>
  button {
    background-color: var(--theme-color-primary);
    border-color: var(--theme-color-primary);
    border-radius: var(--border-radius-small);
    border-style: solid;
    border-width: var(--border-width-light);
    color: var(--color-white);
    cursor: pointer;
    margin: 0.5em;
    padding: 0.5em;

    &:disabled {
      background-color: var(--color-grey);
      border-color: var(--color-grey);
      cursor: default;
    }
  
    &:hover {
      background-color: var(--color-grey);
      border-color: var(--color-grey);
    }
  
    > img {
      height: 1em;
      vertical-align: middle;
    }
  }
</style>
